<template>
  <div class="animated-bg" />
</template>

<script>
export default defineNuxtComponent({
  name: 'Placeholder',
});
</script>

<style>
@reference "~/assets/css/main.css";
.animated-bg {
  animation: fading 1s ease-in-out 2s infinite alternate;
}
@keyframes fading {
  from {
    background-color: var(--color-gray-100);
  }
  to {
    background-color: var(--color-gray-300);
  }
}
</style>
